export class Categoria {
    constructor() {
        this.hm = [];
        //this.hm["C"] = "Convenzione";
        this.hm["E"] = "Evento";
        this.hm["N"] = "News";
        this.hm["B"] = "Bancarella";
        //this.hm["I"] = "Impianto";
        this.hm["L"] = "Modulistica";

        //tipo menu
        this.hm_tm = [];
        this.hm_tm["T"] = "Turismo";
        this.hm_tm["S"] = "Spettacoli";
        this.hm_tm["Z"] = "Sezioni";
        this.hm_tm["C"] = "Convenzioni"; //non commentare
    }

    getTipoByFlag = function(flag) {
        return (this.hm[flag] || '');
    };

    getListaTipi = function() {
        return this.hm;
    };

    getTipoMenuByFlag = function(flag) {
        return (this.hm_tm[flag] || '');
    };

    getListaTipiMenu = function() {
        return this.hm_tm;
    };

}

export class Evento {
    constructor() {
        this.hm = [];
        this.hm["E"] = "Evento";
        this.hm["D"] = "Disponibilità";
        //disabilitato per prenotazioni disabilitate
        //this.hm["G"] = "Giornaliero";
        //this.hm["S"] = "Settimanale";
        ///////////////////////////////////
        this.hm["R"] = "Sorteggio";
        this.hm["O"] = "Sondaggio";
        //disabilitato per ARES, non funzionerebbe niente perchè si basa sull'email
        //this.hm["L"] = "Rimborso Libri";
    }

    getTipoByFlag = function(flag) {
        return (this.hm[flag] || '');
    };

    getListaTipi = function() {
        return this.hm;
    };
}

export class TipoPagamento {
    constructor() {
        this.hm = [];
        this.hm["N"] = "Nessuno";
        this.hm["A"] = "Automatico";
        this.hm["M"] = "Manuale personalizzato per socio";
    }

    getTipoByFlag = function(flag) {
        return (this.hm[flag] || '');
    };

    getListaTipi = function() {
        return this.hm;
    };
}

export class Visibilità {
    constructor() {
        this.hm = [];
        this.hm["T"] = "Tutti";
        this.hm["F"] = "Familiari";
        this.hm["S"] = "Soci";
    }

    getTipoByFlag = function(flag) {
        return (this.hm[flag] || '');
    };

    getListaTipi = function() {
        return this.hm;
    };

}

export class Prenotabilità {
    constructor() {
        this.hm = [];
        this.hm["F"] = "Familiari";
        this.hm["S"] = "Soci";
        this.hm["N"] = "Nessuno";
    }

    getTipoByFlag = function(flag) {
        return (this.hm[flag] || '');
    };

    getListaTipi = function() {
        return this.hm;
    };

}

export class Socio {

    constructor() {
        this.hmruolo = [];
        this.hmruolo["A"] = "Amministratore";
        this.hmruolo["U"] = "Utente";

        this.hmprofilo = [];
        this.hmprofilo["F"] = "Familiare";
        this.hmprofilo["S"] = "Socio";

        this.hmprofilosconti = [];
        this.hmprofilosconti["T"] = "Tutti";
        this.hmprofilosconti["F"] = "Solo familiari";
        this.hmprofilosconti["S"] = "Solo soci";

        this.hmprofilotipoabbonamenti = [];
        this.hmprofilotipoabbonamenti["T"] = "Tutti";
        this.hmprofilotipoabbonamenti["F"] = "Solo familiari";
        this.hmprofilotipoabbonamenti["S"] = "Solo soci";

        this.hmflgatt = [];
        this.hmflgatt["S"] = "Attivo";
        this.hmflgatt["I"] = "Da confermare";
        this.hmflgatt["N"] = "Non attivo";
    }

    getFlgattByFlag = function(flag) {
        return (this.hmflgatt[flag] || '');
    };

    getListaFlgatt = function() {
        return this.hmflgatt;
    };

    getRuoloByFlag = function(flag) {
        return (this.hmruolo[flag] || '');
    };

    getListaRuoli = function() {
        return this.hmruolo;
    };

    getProfiloByFlag = function(flag) {
        return (this.hmprofilo[flag] || '');
    };

    getListaProfili = function() {
        return this.hmprofilo;
    };

    getProfiloScontoByFlag = function(flag) {
        return (this.hmprofilosconti[flag] || '');
    };

    getListaProfiliSconti = function() {
        return this.hmprofilosconti;
    };

    getProfiloTipoAbbonamentoByFlag = function(flag) {
        return (this.hmprofilotipoabbonamenti[flag] || '');
    };

    getListaProfiliTipoAbbonamento = function() {
        return this.hmprofilotipoabbonamenti;
    };

}

export class Partecipa {

    constructor() {

        this.hmstato = [];
        this.hmstato["I"] = "Inserita";
        this.hmstato["O"] = "Overbooked";
        this.hmstato["C"] = "Confermata";
        this.hmstato["P"] = "Pagata";
        this.hmstato["A"] = "Annullata";

    }

    getStatoByFlag = function(flag) {
        return (this.hmstato[flag] || '');
    };

    getListaStati = function() {
        return this.hmstato;
    };

}

export class Prenotazione {

    constructor() {

        this.hmstato = [];
        this.hmstato["I"] = "Inserita";
        this.hmstato["R"] = "Riserva";
        this.hmstato["C"] = "Confermata";
        this.hmstato["P"] = "Pagata";
        this.hmstato["A"] = "Annullata";

    }

    getStatoByFlag = function(flag) {
        return (this.hmstato[flag] || '');
    };

    getListaStati = function(tipo) {
        let hmAux = this.hmstato;
        if (tipo !== "I") {
            delete hmAux["R"];
        }
        return hmAux;
    };

}

export class Bacheca {

    constructor() {

        this.hmstato = [];
        this.hmstato["I"] = "Inserito";
        this.hmstato["C"] = "Confermato";
        this.hmstato["A"] = "Annullato";

    }

    getStatoByFlag = function(flag) {
        return (this.hmstato[flag] || '');
    };

    getListaStati = function() {
        return this.hmstato;
    };

}

// export class RimborsoLibri {

//     constructor() {

//         this.hmstato = [];
//         this.hmstato["I"] = "Inserita";
//         this.hmstato["A"] = "In lavorazione";
//         this.hmstato["P"] = "In pagamento";
//         this.hmstato["D"] = "Da rettificare";
//         this.hmstato["R"] = "Rettificata";
//         this.hmstato["F"] = "Rifiutata";
//     }

//     getStatoByFlag = function(flag) {
//         return (this.hmstato[flag] || '');
//     };

//     getListaStati = function() {
//         return this.hmstato;
//     };

// }

export class Documento {

    constructor() {
        this.hm = [];
        this.hm["C"] = "Certificato medico";
        this.hm["I"] = "Documento identità";
        this.hm["A"] = "Altro";

        this.hmstato = [];
        this.hmstato["I"] = "Inserito";
        this.hmstato["C"] = "Confermato";
        this.hmstato["A"] = "Annullato";
    }

    getTipoByFlag = function(flag) {
        return (this.hm[flag] || '');
    };

    getListaTipi = function() {
        return this.hm;
    };

    getStatoByFlag = function(flag) {
        return (this.hmstato[flag] || '');
    };

    getListaStati = function() {
        return this.hmstato;
    };

}

export class TipoQuestionario {

    constructor() {
        this.hm = [];
        this.hm["E"] = "Evento";
        //this.hm["C"] = "Convenzione";
        //this.hm["I"] = "Impianto";
        this.hm["N"] = "News";
        this.hm["C"] = "Bancarella";
    }

    getTipoByFlag = function(flag) {
        return (this.hm[flag] || '');
    };

    getListaTipi = function() {
        return this.hm;
    };

}

export class FlgmaxprenoImpianto {

    constructor() {
        this.hm = [];
        this.hm["N"] = "Nessuno";
        this.hm["G"] = "Giornaliero";
        this.hm["S"] = "Settimanale";
        this.hm["M"] = "Mensile";
        this.hm["A"] = "Annuale";
    }

    getTipoByFlag = function(flag) {
        return (this.hm[flag] || '');
    };

    getListaTipi = function() {
        return this.hm;
    };

}

export class Orario {

    constructor() {
        this.hm = [];
        this.hm[null] = "";
        this.hm["1"] = "Domenica";
        this.hm["2"] = "Lunedì";
        this.hm["3"] = "Martedì";
        this.hm["4"] = "Mercoledì";
        this.hm["5"] = "Giovedì";
        this.hm["6"] = "Venerdì";
        this.hm["7"] = "Sabato";
    }

    getGiornoSettimanaByNumero = function(num) {
        return (this.hm[num] || '');
    };

    getGiorniSettimana = function() {
        return this.hm;
    };


}

export class PrenotazioniPEStorico {
    constructor() {
        this.hmt = [];
        this.hmt["R"] = "Ricezione prodotti";
        this.hmt["I"] = "Invio prenotazione";
        this.hmt["P"] = "Esito prenotazione";
    }

    getTipoByFlag = function(flag) {
        return (this.hmt[flag] || '');
    };

    getListaTipi = function() {
        return this.hmt;
    };

}
